import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const GetOrganizationSurveys = async ({
    orgId
}: {
    orgId: string;
}): Promise<{ surveys: ISurveyFull[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ surveys: ISurveyFull[]; totalRecords: number }>({
            // port: '8080',
            path: `organizations/${orgId}/surveys`,
            method: 'GET'
        });

        if ('surveys' in response && Array.isArray(response.surveys)) return response;
        return null;
    } catch (e) {
        console.error('Get org surveys request failed');
        return Promise.reject(e);
    }
};
